import {ProjectDiagramComponent} from '@catdetails/components/project-diagram/project-diagram.component';

export {ProjectDetailsComponent} from './project-details/project-details.component';
export {ProjectDiagramComponent} from './project-diagram/project-diagram.component';
export {ProjectPropertiesComponent} from './project-properties/project-properties.component';
export {SwitchLogicSelectComponent} from './switch-logic-select/switch-logic-select.component';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/components/index.ts